import axios, { AxiosInstance } from 'axios';

let stream_api: AxiosInstance | null = null;

function init() {
  if (!stream_api) {
    stream_api = axios.create({
      baseURL: process.env.NEXT_PUBLIC_CLASS_API,
      withCredentials: true,
    });
  }

  return stream_api;
}

export interface OnlineLessonLogRequest {
  online_class_id: number;
  mode: string;
  subject_id: number;
  last_watched_second?: number;
  watch_percentage?: number;
  start_time?: number;
  duration?: number;
  end_time?: number;
  device_type: string;
}

export default function ClassService() {
  const api = init();
  return {
    activity: function (params: OnlineLessonLogRequest) {
      return api.post('/student/log/activity', params);
    },
  };
}
